import React, { useEffect } from 'react'
import {
  makeStyles,
  Card,
  CardContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  // MenuItem,
  Button,
  Divider,
  Typography,
  CircularProgress,
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useNavigate, useParams } from 'react-router-dom'
import { debounce } from 'lodash'
import { getAllAgeCategories, selectorAgeCategories } from 'src/app/slices/notificationSlice'
// import { selectorEventStages } from 'src/app/slices/eventSlice'
import {
  createGroup, getGroupMembers, addMembers, deleteMembers, getGroups,
} from '../../app/slices/refereeGroupsSlice'
import { getUsers } from '../../app/slices/usersSlice'
import { CssTextField, StyledMenuItem } from '../../utils/CustomInputs'
// import muiDefaultOptions from '../../constants/muiTableOptions'

const useStyle = makeStyles(() => ({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: '#f9b233',
    },
    '& .MuiOutlinedInput-input:focus': {
      outline: 'red',
    },
    '& .MuiMenuItem-root': {
      '&:hover': {
        backgroundColor: '#f9b233',
      },
    },
    '.MuiMenuItem-root': {
      backgroundColor: '#f9b233',
    },
  },
  inputs: {
    width: '100%',
  },
}))

const validationSchema = yup.object({
  name: yup
    .string('لطفا نام گروه را وارد کنید')
    .required('نام گروه الزامی است.'),
  age: yup
    .string('نقش را انتخاب کنید.')
    .required('انتخاب نقش الزامی است'),
})

const GroupForm = () => {
  const classes = useStyle()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // const { groupId, groupName, ageId } = useParams()
  const { groupId } = useParams()
  const ages = useSelector(selectorAgeCategories)
  const groups = useSelector((state) => state.refereeGroups.list)
  const loggedInUser = useSelector((state) => state.user)
  const roles = useSelector((state) => {
    if (loggedInUser.role.roleId === 5) {
      return state.common.roles.filter((role) => role.roleId === 6)
    } if (loggedInUser.role.roleId === 3) {
      return state.common.roles.filter(
        (role) => (
          role.roleId !== 2 && role.roleId !== 1 && role.roleId !== 8 && role.roleId !== 3
        ),
      )
    } if (loggedInUser.role.roleId === 2) {
      return state.common.roles.filter((role) => role.roleId !== 1)
    }
    return []
  })

  useEffect(() => {
    dispatch(getUsers({
      roleIds: roles.map((role) => role.roleId),
      after: 0,
      first: 1000,
      full: true,
    }))
    dispatch(getGroups({}))
    dispatch(getAllAgeCategories())
  }, [])

  const group = groups?.find((g) => +g?.id === +groupId)
  const ageCategory = ages?.find((age) => +age?.ageCategoryId
   === +group?.ageCategory?.ageCategoryId)

  const formik = useFormik({
    initialValues: {
      name: group?.name || '',
      age: ageCategory?.ageCategoryId
        ? parseInt(ageCategory?.ageCategoryId, 10) : '',
      type: group?.type || '',
    },
    validationSchema,
    onSubmit: (values) => {
      if (groupId) return
      dispatch(createGroup({
        name: values.name,
        ageCategory: {
          ageCategoryId: values.age,
        },
        type: loggedInUser?.role?.roleId === 10 ? 2 : 1,
      }, (data) => {
        // navigate(`../edit/${data}/${values.age}/${values.name}`)
        navigate(`../edit/${data}`)
      }))
    },
  })

  return (
    <Card className={classes.root}>
      <CardContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>

            <Grid item xs={12} sm={6}>
              <CssTextField
                fullWidth
                variant="outlined"
                // disabled={!!groupId}
                disabled={group?.name}
                id="name"
                name="name"
                label="نام گروه"
                autoFocus
                value={group?.name ?? formik.values.name}
                onChange={formik.handleChange}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" fullWidth className={classes.formControl}>
                <InputLabel id="ageLable">گروه سنی</InputLabel>
                <Select
                  labelId="ageLable"
                  id="age"
                  name="age"
                  disabled={ageCategory?.name}
                  value={ageCategory?.ageCategoryId || formik.values.age}
                  onChange={formik.handleChange}
                  label="گروه سنی"
                >
                  {ages && ages?.map((age) => (
                    <StyledMenuItem value={ageCategory?.ageCategoryId || age?.ageCategoryId}>
                      {ageCategory?.name || age?.name}
                    </StyledMenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: groupId ? 'none' : '',
              }}
            >
              <Button color="primary" variant="contained" fullWidth type="submit">
                ذخیره
              </Button>
            </Grid>
            {groupId ? <Grid item xs={12}><GroupMembers groupId={groupId} /></Grid> : null}
          </Grid>
        </form>

      </CardContent>
    </Card>
  )
}

const GroupMembers = ({ groupId }) => {
  // const classes = useStyle()
  const dispatch = useDispatch()
  const options = useSelector((state) => state.users.list)

  const [open, setOpen] = React.useState(false)
  const [searchTerm, setSearchTerm] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [initialMembers, setInitialMembers] = React.useState([])
  const [members, setMembers] = React.useState([])
  // const eventStates = useSelector(selectorEventStages)

  const updateSearchTerm = debounce((term) => {
    setSearchTerm(term)
  }, 500, { maxWait: 1000 })

  useEffect(() => {
    setLoading(true)
    dispatch(getGroupMembers(groupId, (data) => {
      setInitialMembers(data)
      setMembers(data)
      setLoading(false)
    }))
  }, [])

  useEffect(() => {
    setLoading(true)
    dispatch(getUsers({
      userName: searchTerm,
      roleIds: [6],
      first: 10,
      after: 0,
    }, () => {
      setLoading(false)
    }))
  }, [searchTerm])

  // useEffect(() => {
  //   dispatch(getEventStages())
  // }, [])

  const updateMembers = (e) => {
    e.preventDefault()
    const currentMemberIds = members.map((member) => member.userId)
    const initialMemberIds = initialMembers.map((member) => member.userId)
    const deletedMembers = initialMembers.filter(
      (member) => !currentMemberIds.includes(member.userId),
    )
    const addedMembers = members.filter(
      (member) => !initialMemberIds.includes(member.userId),
    )

    if (addedMembers.length) {
      dispatch(addMembers(addedMembers, groupId, (rejectes) => {
        if (rejectes && rejectes.length) {
          setMembers(members.filter((member) => !rejectes.includes(member.userId)))
        }

        if (deletedMembers.length) {
          dispatch(deleteMembers(deletedMembers, (deleteRejectes) => {
            if (deleteRejectes && deleteRejectes.length) {
              const notDeletedMembers = initialMembers.filter(
                (member) => rejectes.includes(member.userId),
              )
              setMembers(members.concat(notDeletedMembers))
            }
            setInitialMembers(members)
            setLoading(false)
          }))
        } else {
          setInitialMembers(members)
          setLoading(false)
        }
      }))
    }
  }

  const deletedReferee = (deletedMembers) => {
    dispatch(deleteMembers(deletedMembers))
  }

  return (
    <>
      <Divider style={{ margin: '20px 0' }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            color="textPrimary"
            variant="h5"
          >
            داوران گروه:
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            multiple
            filterSelectedOptions
            style={{ width: '100%' }}
            open={open}
            onOpen={() => {
              setOpen(true)
            }}
            onClose={() => {
              setOpen(false)
            }}
            value={members}
            getOptionLabel={(option) => option.userName}
            options={options}
            loading={loading}
            onInputChange={(event, newInputValue) => {
              updateSearchTerm(newInputValue)
            }}
            onChange={(event, newValue) => {
              setMembers(newValue)
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="داوران"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress
                          onClick={deletedReferee}
                          color="inherit"
                          size={20}
                        />
                      ) : null}
                      <span onClick={() => deletedReferee(members)}>
                        {params.InputProps.endAdornment}
                      </span>
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>
        {/* <Grid item xs={12} sm={6}>
          <FormControl variant="outlined" fullWidth className={classes.formControl}>
            <InputLabel id="ageLable">گروه سنی</InputLabel>
            <Select
              labelId="ageLable"
              id="age"
              name="age"
              // disabled={ageCategory?.name}
              // value={ageCategory?.ageCategoryId || formik.values.age}
              // onChange={formik.handleChange}
              label="گروه سنی"
            >
              {eventStates?.length && eventStates?.map((stage) => (
                <StyledMenuItem key={stage?.id} value={stage?.id}>
                  {stage?.title}
                </StyledMenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
        <Grid item xs={12}>
          <Button color="primary" disabled={loading} onClick={updateMembers} variant="contained" fullWidth type="submit">
            ذخیره
          </Button>
        </Grid>
      </Grid>
    </>
  )
}

export default GroupForm
